import { Routes } from '@angular/router';
import { canDeactivateGuard } from './guards/can-deactivate.guard';

export const routes: Routes = [
  /*   {
      path: '',
      redirectTo: 'menu',
      pathMatch: 'full', // redirige si la URL está completamente vacía
    }, */
  {
    path: 'menu',
    loadComponent: () => import('./pages/menu/menu.page').then((m) => m.MenuPage),
  },
  {
    path: 'checkout',
    loadComponent: () => import('./pages/checkout/checkout.page').then(m => m.CheckoutPage)
  },
  {
    path: 'payment-method',
    loadComponent: () => import('./pages/payment-method/payment-method.page').then(m => m.PaymentMethodPage)
  },
  {
    path: 'successful',
    loadComponent: () => import('./pages/successful/successful.page').then(m => m.SuccessfulPage),
    canDeactivate: [canDeactivateGuard]
  },
  /*   {
      path: 'blank-loader',
      loadComponent: () => import('./pages/blank-loader/blank-loader.page').then( m => m.BlankLoaderPage)
    }, */
  {
    path: 'legal',
    loadComponent: () => import('./pages/legal/legal.page').then(m => m.LegalPage)
  },
  {
    path: 'legal-qr',
    loadComponent: () => import('./pages/legal-qr/legal-qr.page').then(m => m.LegalQrPage)
  },
  {
    path: 'privacy',
    loadComponent: () => import('./pages/privacy/privacy.page').then(m => m.PrivacyPage)
  },
  {
    path: 'terms',
    loadComponent: () => import('./pages/terms/terms.page').then(m => m.TermsPage)
  },
  {
    path: 'info',
    loadComponent: () => import('./pages/info/info.page').then(m => m.InfoPage)
  },
  {
    path: 'search',
    loadComponent: () => import('./pages/search/search.page').then(m => m.SearchPage)
  },
  {
    path: 'scan-required',
    loadComponent: () => import('./pages/scan-required/scan-required.page').then(m => m.ScanRequiredPage)
  },
  {
    // Manejador de acciones de email de Firebase Auth (custom action URL).
    // Configurar en Console: Authentication → Templates → Customize action URL
    // → https://app.barpify.com/auth/action
    path: 'auth/action',
    loadComponent: () => import('./pages/auth-action/auth-action.page').then(m => m.AuthActionPage)
  },

  //Redirección en caso de fallo de ruta
  {
    path: '**',
    loadComponent: () => import('./pages/scan-required/scan-required.page').then(m => m.ScanRequiredPage)
  },



];
